import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteJoin, offSetJoin } from "./joinsSlice";

const initialState = [];

export const deleteForm = createAsyncThunk(
    'forms/delete',
    async (index, { getState, dispatch }) => {
        const joins = getState().joins;
        const joinsToDelete = [];

        joins.forEach((join, i) => {
            const { position } = join;
            if (position.includes(index)) {
                joinsToDelete.push(i);
            }
        })


        joinsToDelete.reverse().forEach((join) => dispatch(deleteJoin(join)));
        dispatch(offSetJoin(index));
        return index;
    }
)

export const formsSlice = createSlice({
    name: "forms",
    initialState,
    reducers: {
        addForm: (state, { payload }) => { state.push(payload) },
        deleteForm: (state, { payload }) => { state.splice(payload, 1) },
        resetForm: () => []
    },
    extraReducers: (builder) => {
        builder.addCase(deleteForm.fulfilled,
            (state, { payload }) => {
                state.splice(payload, 1)
            })
    }
})
export const { addForm, resetForm } = formsSlice.actions

export default formsSlice.reducer